<template>
  <div class="r-ipt common-flex common-align-center common-justify-between">
      <div class="title">{{config.label}}<span style="color:red" v-if="config.must">*</span></div>
      <div style="font-size:14px;font-weight:700">{{config.textvalue}}</div>
  </div>
</template>

<script>

export default {
  name: "r-ipt",
  data() {
    return {

    };
  },
  /*label 标题
    must 是否必填,
    type 类型,
    textvalue  显示数据
  */
  props:{
      config:Object
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-ipt{
    width: 350px;
    padding-bottom: 12px;
    border-bottom: 1px solid #B4BAC3;
    .title{
        width: 170px;
        line-height: 32px;

    }
    input{
        width: 170px;
        // text-align: right;
        height: 32px;
        line-height: 32px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/r-text.vue